import React from 'react';

import { BsArrowUpRight } from 'react-icons/bs';

import {motion} from 'framer-motion'
import {fadeIn} from '../variants' 

const services = [
  {
    name: 'UI/UX  Design',
    description : 'Transforming web experiences is my passion. With 12 months of web development experience, Ive shifted gears to specialize in UI/UX design. My mission? To craft visually stunning and user-centric interfaces that captivate and engage . I dive deep into design secrets, wield top-notch tools, and inject creativity into every project. User satisfaction is my priority; feedback is my compass . Join me on this journey to elevate your digital presence. Welcome to a world of captivating and functional design, where your ideas come to life ',
                
    link: 'Learn more'
  },
  {
    name: 'Development',
    description : 'With [12 months] of hands-on experience, Im a results-driven developer who thrives on turning ideas into digital solutions. I specialize in crafting user-friendly websites and robust software applications, embracing the latest technologies and best practices. My commitment to clean, scalable code ensures lasting quality. Lets bring your ideas to life in the digital world',
    link: 'Learn more'
  },
  {
    name: 'Digital Marketing',
    description : 'As a digital marketing enthusiast, I excel in navigating the ever-evolving landscape of online strategies. With a strong foundation in SEO, social media management, PPC campaigns, and content marketing, Ive consistently driven results for clients and businesses. My approach blends data-driven insights with creativity to craft impactful campaigns that capture attention and drive engagement. Lets connect and explore how I can help elevate your online presence and grow your digital footprint. ',
    link: 'Learn more'
  },
]  

const Services = () => {
  return ( 
      <section className='section' id='services'>
        <div className='container mx-auto'>
          <div className='flex flex-col lg:flex-row'>
            {/* Text + Image */}
            <motion.div
            variants={fadeIn('right', 0.4)}
            initial="hidden"
            whileInView={"show"}
            viewport={{once: false, amount: 0.3}}
             className='flex-1 lg:bg-services lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0'>
              <h2 className='h2 text-accent mb-6'>What I offer </h2>
              <h3 className='h3 max-w-[455px] mb-16'>As a Freelance front-end web Developer </h3>
              
            </motion.div>
            {/* services */}
            <motion.div 
             variants={fadeIn('left', 0.5)}
             initial="hidden"
             whileInView={"show"}
             viewport={{once: false, amount: 0.3}}
             className='flex-1'>
              {/*service list*/}
              <div >
                {services.map((service, index)=> {
                  //destructure service
                  const {name, description, link} = service;
                  return (
                  <div className=' h-[246px] mb-[38px] flex' key={index}>
                    <div className='max-w-[476px]'>
                      <h4 className='text-[20px] tracking-wider font-primary font-semibold mb-6'>{name}</h4>
                      <p className='font-secondary leading-tight'>{description}</p>
                    </div>
                    <div className='flex flex-col flex-1 items-end'>
                      <a href="#" className='btn w-9 h-9 mb-[42px] justify-center items-center'>
                        <BsArrowUpRight/>
                        </a>
                        <a href='#' className='text-gradient text-sm'>{link}</a>
                    </div>
                  </div>
                  );
                })}
              </div>
            </motion.div> 
          </div>
        </div>
      </section>
  );
};

export default Services;
